module.exports = __webpack_public_path__ + "static/media/HomePic8.b9a8a6b2.jpeg";